import '@scripts/js/polyfills';
import '@scripts/js/imask';
import '@scripts/ts/index.ts';
import '@styles/scss/index.scss';
